module.exports = __webpack_public_path__ + "static/media/vi.4952d5bf.svg";